import { Address } from './address';
import { TcCard } from './raffle';

export interface User {
  name?: string;
  surname1?: string;
  surname2?: string;
  status?: number;
  documentNumber?: string;
  documentType?: UserDocumentType;
  phone?: string;
  email?: string;
  birthdate?: string;
  address?: Address;
  userCode?: string;
  userId?: string;
  additionalUserIds?: string[];
  secondPhone?: string;
  tokenPass?: string;
  token?: string;
  refreshToken?: string;
  policyAccepted?: boolean;
  nuumaSim?: string;
  legalRepresentative?: CompanyLegalRepresentative;
  mcaOnboarding?: string;
}
export interface CompanyLegalRepresentative {
  name: string;
  surname1: string;
  surname2: string;
  documentNumber: string;
  documentType: UserDocumentType;
  phone: string;
  email: string;
  birthdate: string;
}

export enum UserDocumentType {
  CIF = 'CIF',
  NIF = 'NIF',
  NIE = 'NIE'
}

export enum TeCuidamosUserType {
  LOGIN,
  SIGNUP,
  CANT,
  ERROR
}

export enum RatingType {
  PLATINUM = 1,
  GOLD = 2,
  SILVER = 3
}

export const WILLMANAGEMENT_DOCUMENTS = 'documentsNumberWillManagement';

export interface TeCuidamos {
  memberState: TeCuidamosUserType;
  membershipType: string;
  clientId: string;
  customerSupportPhoneNumber: string;
  cardComponentId: string;
  pan: string;
  titleLine1: string;
  textLine1: string;
  titleLine2: string;
  textLine2: string;
  backText: string;
  teCuidamosURL: string;
  policiesSectionMark: boolean;
  rgpdCheckText: string;
  rgpdText: string;
  rgpdTitle: string;
}

export interface TeCuidamosUser {
  documentNumber: string;
  documentType: string;
  email: string;
  errorCode: string;
  mobilePhone: string;
  name: string;
  surname1: string;
  surname2: string;
  partnerInd: string;
  status: 'REGISTERED' | 'NOT_REGISTERED' | 'NOT_ALLOWED_REGISTER';
}

export interface Clover {
  achievedClovers?: number;
  redeemedClovers?: number;
  redeemPendingClovers?: number;
}

export interface Rating {
  customerRating?: RatingType;
}

export interface TeCuidamosUserData
  extends TeCuidamos,
    Clover,
    Rating,
    TcCard {}

export interface CloverMovement {
  transactionList: CloverTransaction[];
  totalCount: number;
}

export interface CloverTransaction {
  date: any; // 20100622 YYYYmmdd from services
  description: string;
  amount: number;
  clovers: number;
  partnerPercentage: number;
  cardPercentage: number;
  bankinter?: boolean;
}

export interface CloverPolicy {
  policyNumber: string;
  dueDate: string;
  effectiveDate: string;
  risk: string;
  selected: boolean;
  sector: string;
}

export interface TeCuidamosRegister {
  name: string;
  surname1: string;
  surname2?: string;
  status?: string;
  sex: string;
  documentNumber: string;
  email: string;
  date: string;
  mobile: string;
  phone?: string;
  streetType: string;
  street: string;
  number: string;
  postalCode: string;
  location: string;
  additionalAddressInfo?: string;
  province?: string;
  provinceCode?: string;
}

export interface TeCuidamosRaffleOption {
  name: string;
  title: string;
  description: string;
  img: string;
}

export enum UserLoginStatus {
  NOT_FOUND = '-1',
  ACTIVE_BUT_BLOCKED = '5',
  OPERATIVE = '6',
  INACTIVE = '8',
  FORGET_PROCCESS_PENDING = '9',
  BLOCKED_ONE_DAY = '10',
  CAMPAIGN_INACTIVE = '20',
  CANCELLED = 'CANCELLED',
  IS_CANCELLED = 'USER_IS_CANCELED',
  INVALID = 'BAD_AUTHENTICATION',
  INVALID_LOGIN = 'LOGIN_INVALID_ORIGIN_DATA'
}

export enum ForgotPasswordOrigin {
  FROM_LOGIN,
  FROM_LINK
}

export function getFullName(insured: User) {
  let fullName = '';
  if (insured.name) {
    fullName += insured.name + ' ';
  }
  if (insured.surname1) {
    fullName += insured.surname1 + ' ';
  }
  if (insured.surname2) {
    fullName += insured.surname2 + ' ';
  }
  if (fullName.length === 0) {
    return null;
  } else {
    return fullName.trim();
  }
}
